import { createFeatureSelector } from '@ngrx/store';

export const selectVisual = createFeatureSelector('visual');
